export default {
    page_title: "Kevi | Message Report",
    title: "Messages",
    modal: {
        title: "Notification",
    },
    stats: {
        total: "Messages",
        email: "Emails",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        oficial_whatsapp: "Official WhatsApp",
        accepted: "Accepted",
        sent: "Sent",
        failed: "Failed",
        scheduled: "Scheduled",
        queued: "Processing",
    },
    table: {
        message: "Message",
        sender: "Sender",
    },
    content: {
        subject_prefix: "Subject: ",
    },
    filters: {
        automation: "Automation",
        sender: {
            label: "Sender",
        },
        status: {
            label: "Status",
            options: {
                accepted: "Accepted",
                scheduled: "Scheduled",
                sent: "Sent",
                failed: "Failed",
                queued: "Processing",
            },
        },
        method: {
            label: "Method",
            options: {
                email: "Email",
                sms: "SMS",
                rcs: "RCS",
                whatsapp: "WhatsApp",
                whatsapp_cloud: "Official WhatsApp",
            },
        },
    },
    actions: {
        retry_failed_aria: "Retry failed messages",
        retry_failed_tooltip: "Try again",
        cancel_scheduled_aria: "Cancel scheduled messages",
        cancel_scheduled_tooltip: "Cancel scheduling",
        view_email_body: "View email body",
    },
    confirmations: {
        retry_failed: "Do you want to resend the {0} failed messages now?",
        cancel_scheduled: "Do you really want to cancel scheduled messages?",
    },
    toasts: {
        retry_success: "Messages returned to queue",
        cancel_success: "Messages canceled",
    },
};
